var _circle, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChallengeAction(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.5,
    r: 12,
    fill: "url(#a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.429 13.446a4.024 4.024 0 0 1-2.989.727v3.359a.776.776 0 0 0 .123.445c.215.315.62.29.898.079l2.02-1.303h5.76c.514 0 1.1-.586 1.1-1.1v-5.296a.933.933 0 0 0-.924-.941H13.02a4.065 4.065 0 0 1-.067 1.815h2.74a.37.37 0 0 1 0 .739h-3.02c-.13.263-.288.51-.471.738h3.49a.37.37 0 0 1 0 .738H11.43zm-1.44 1.107a.37.37 0 0 1 .369-.369h5.336a.37.37 0 1 1 0 .738h-5.336a.37.37 0 0 1-.37-.369z",
    fill: "#fff",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.051 13.569a3.392 3.392 0 1 0 0-6.783 3.392 3.392 0 0 0 0 6.783zm0-5.572a.532.532 0 0 0-.393.174.542.542 0 0 0-.139.41l.215 2.235.001.01a.32.32 0 0 0 .316.284.32.32 0 0 0 .318-.294l.215-2.235v-.014a.542.542 0 0 0-.14-.396.532.532 0 0 0-.393-.174zm0 3.661a.348.348 0 0 0-.346.35c0 .193.155.35.346.35a.348.348 0 0 0 .347-.35.348.348 0 0 0-.347-.35z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 24,
    y1: 0.5,
    x2: -0.598,
    y2: 1.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3FCB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DE995"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChallengeAction);
export default __webpack_public_path__ + "static/media/challengeAction.4c4785befd86a057e1fb6cc00eb44cf1.svg";
export { ForwardRef as ReactComponent };